const IE = "en-IE";
const TZ = "Europe/Dublin";

export const n = (x) => Number(x || 0).toLocaleString(IE);

export const compact = (x) => {
  const v = Number(x || 0);
  if (v < 1000) return String(v);
  return `${(v / 1000).toFixed(1).replace(/\.0$/, "")}k`;
};

const fmt = (iso, opts) => (iso ? new Intl.DateTimeFormat(IE, { timeZone: TZ, ...opts }).format(new Date(iso)) : "");
export const fmtDate = (iso) => fmt(iso, { day: "numeric", month: "long", year: "numeric" });
export const fmtShort = (iso) => fmt(iso, { day: "numeric", month: "short", year: "numeric" });
export const fmtDayMonth = (iso) => fmt(iso, { day: "numeric", month: "short" });
export const fmtTime = (iso) => fmt(iso, { hour: "2-digit", minute: "2-digit", hour12: false });
export const fmtDateTime = (iso) => (iso ? `${fmtShort(iso)}, ${fmtTime(iso)}` : "");

export const ago = (iso) => {
  if (!iso) return "";
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 2) return "just now";
  if (mins < 60) return `${mins} minutes ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  const days = Math.round(hours / 24);
  if (days === 1) return "yesterday";
  return `${days} days ago`;
};

export const lastActive = (iso) => {
  if (!iso) return "Never";
  const a = ago(iso);
  if (a.includes("minute") || a.includes("hour") || a === "just now") return "Today";
  if (a === "yesterday") return "Yesterday";
  const days = Math.round((Date.now() - new Date(iso).getTime()) / 86400000);
  return days < 14 ? a : fmtShort(iso);
};

export const MEDIA_LABEL = { slider: "Before and after", image: "Single image", video: "Video" };
export const STATUS_LABEL = { draft: "Draft", review: "In review", approved: "Approved", live: "Live", rejected: "Rejected" };
export const ADMIN_STATUS_LABEL = { ...STATUS_LABEL, review: "To review" };
